import { Fragment } from "react";
import { TableCell, AccordionSummary, Accordion, AccordionDetails, Box, Divider } from "@mui/material";

import { FeatureItemIcon, FeaturesAccordionIcon } from "../../../assets/icons/plans-icons";

import { plansListStyles } from "./styles";

type featuresType = {
  title: string;
  features: string[];
};

type FeaturesCellProps = {
  features: featuresType[];
};

const FeaturesCell = ({ features }: FeaturesCellProps) => {
  if (features.length === 0) {
    return (
      <TableCell
        component="td"
        scope="row"
        sx={{
          ...plansListStyles.tablePlanItemCell,
          verticalAlign: "top",
        }}
      />
    );
  }
  return (
    <TableCell
      component="td"
      scope="row"
      sx={{
        ...plansListStyles.tablePlanItemCell,
        verticalAlign: "top",
      }}
    >
      <Box sx={styles.featuresContainer}>
        {features.map(({ title, features: featureList }, idx) => (
          <Fragment key={title}>
            <Accordion sx={styles.accordion}>
              <AccordionSummary
                sx={styles.accordionSummary}
                expandIcon={<FeaturesAccordionIcon />}
                aria-controls={`features-accordion-${title}`}
                id={`features-accordion-${title}`}
              >
                {title}
              </AccordionSummary>
              <AccordionDetails sx={styles.accordionDetails}>
                <Box component="ul" sx={styles.featuresList}>
                  {featureList.map((feature: string) => (
                    <Box component="li" key={feature} sx={styles.feature}>
                      <FeatureItemIcon />
                      {feature}
                    </Box>
                  ))}
                </Box>
              </AccordionDetails>
            </Accordion>
            {idx !== features.length - 1 && <Divider orientation="horizontal" flexItem />}
          </Fragment>
        ))}
      </Box>
    </TableCell>
  );
};

export default FeaturesCell;

const styles = {
  featuresContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  accordion: {
    borderRadius: "0",
    border: "none",
    borderTop: "none",
    borderBottom: "none",
    background: "transparent",
    boxShadow: "none",
    "&:before": {
      display: "none",
    },
    "&.Mui-expanded": {
      margin: "0",
      "&:before": {
        display: "none",
      },
    },
  },
  accordionSummary: {
    color: "var(--Gray-900, #101828)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "24px",

    padding: "0",
    minHeight: "unset",
    border: "none",
    borderTop: "none",
    borderBottom: "none",
    "& .MuiAccordionSummary-content": {
      margin: "0",
    },
    "&.Mui-expanded": {
      minHeight: "unset",
    },
  },
  accordionDetails: {
    padding: "0",
    paddingTop: "16px",
    minHeight: "unset",
  },
  feature: {
    fontFamily: "Montserrat",
    color: "var(--Dark---800, #414141)",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  featuresList: {
    padding: "0",
    margin: "0",
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
};
